/** @jsxImportSource @emotion/react */

import { Row } from "react-grid-system";
import DetailsSection from "../../../../../components/Details/components/Main/Section/DetailsSection";
import useConfirmedAction from "../../../../../hooks/useConfirmedAction";
import useDocumentDetails from "../../../../../hooks/useDocumentDetails";
import { IconNames } from "../../../../../components/Icons/styles/iconNames";
import InsuranceInfo from "./components/InsuranceInfo";
import SelectUsers from "./components/OperationalActions";
import BasicInfo from "./components/BasicInfo";
import { FC } from "react";

const DocumentSummary: FC = () => {
  const {
    documentData: { archived },
    handleArchive,
  } = useDocumentDetails();

  const onArchive = useConfirmedAction(
    `Tem certeza de que deseja ${
      archived ? "desarquivar" : "arquivar"
    } este documento?`,
    handleArchive
  );

  const footerButtons = [
    {
      text: archived ? "Desarquivar" : "Arquivar",
      iconName: archived ? IconNames.Unarchive : IconNames.Archive,
      onClick: onArchive,
    },
  ];

  return (
    <DetailsSection
      title="Dados gerais"
      noTitle
      main
      footerButtons={footerButtons}
    >
      <Row>
        <InsuranceInfo />
        <SelectUsers />
      </Row>
      <Row>
        <BasicInfo />
      </Row>
    </DetailsSection>
  );
};

export default DocumentSummary;
